import { Link, useLocation } from "react-router-dom";
import CreditListPerSong from "./CreditListPerSong";
import React, {
  Key,
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  ReactPortal,
  useState,
  useEffect
} from "react";
// import ShareIcon from "../images/arrow-up-from-bracket-solid.svg?react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { encodeId } from "./HelperMethods";
import { Song, Credits, ArtistInfo, AlbumInfo, SongDetailsProps } from "../types";
import ReviewsContainer from "./Review/ReviewsContainer";
import UserRatingUI from "./Common/UserRatingUI";
import "../pages/Song/Song.css";

// Credits type expected by CreditListPerSong component
interface CreditListProps {
  credits: Array<{
    _id: string;
    artist_id: number;
    english_name: string;
    korean_name?: string;
    s3_picture_url?: string;
  }>;
}

function showSongHeader(song: Song, featured: Credits[], artistinfo: ArtistInfo[], albuminfo: AlbumInfo, type: string) {
  const album_id = song.melon_album_id;
  const titleTrackTooltip = <Tooltip id="title-track-tooltip">Title track</Tooltip>;

  return (
    <div className={"song-header" + type}>

      <div className="main-song-text">
        <h1 className="song-name">
          {song.english_name && song.is_title && (
            <OverlayTrigger placement="bottom" overlay={titleTrackTooltip}>
              <span>✰</span>
            </OverlayTrigger>
          )}
          {song.english_name && song.is_explicit && "🅴 "} {song.english_name}
          {song.korean_name && <div className="korean-small-text"> {song.korean_name && " (" + song.korean_name + ")"}</div>}
        </h1>
      </div>
      <div className="artist-credits-list">
        <div className="main-performer-list">
          by{artistinfo &&
            artistinfo.map((name) => {
              const artistName = typeof name.artist_english_name === 'string'
                ? name.artist_english_name
                : '';

              return (
                <div className="artist-credit-link" key={name.artist_id}>
                  <Link
                    to={`/artist/${encodeId(name.artist_id)}`}
                    state={{ id: name.artist_id }}
                  >
                    {name.artist_id !== -1 ? artistName : ''}
                  </Link>
                  {name.artist_id === -1 ? artistName : ''}
                </div>
              );
            })}
        </div>
        {featured.length > 0 && (
          <div className="featured-list">
            featuring
            {featured.map((credit) => (
              <p className="credits-list-inner" key={credit._id}>
                <Link
                  to={`/artist/${encodeId(credit.artist_id)}`}
                  state={{ id: credit.artist_id }}
                >
                  {credit.english_name}
                </Link>
              </p>
            ))}
          </div>
        )}
      </div>
      <h5 className="album-name-song-page-mobile" style={{ "marginBottom": "0em" }}>
        {song.spotify_song_id &&
          <a href={`https://open.spotify.com/track/${song.spotify_song_id}`} target="_blank" rel="noopener noreferrer">
            <img src="/spotify_logo.png" alt="Listen on Spotify" style={{ width: "16px", height: "16px", boxShadow: "none" }} />
          </a>
        }
        TRACK {song.track_order} ON{" "}
        <Link to={`/album/${encodeId(album_id)}`} state={{ id: album_id }} className="album-link-mobile">
          {albuminfo.album_english_name.toUpperCase()}
        </Link>
      </h5>
    </div>);
}

const SongDetails: React.FC<SongDetailsProps> = ({
  song,
  credits,
  artistinfo,
  albuminfo,
}) => {
  const album_id = song.melon_album_id;
  const featured = credits.filter((c) => c.credit_type.includes("F"));
  const written = credits.filter((c) => c.credit_type.includes("L"));
  const composed = credits.filter((c) => c.credit_type.includes("C"));
  const arranged = credits.filter((c) => c.credit_type.includes("A"));
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('details');

  var picture_url = "";
  if ('s3_picture_url' in albuminfo && typeof albuminfo.s3_picture_url === 'string') {
    picture_url = albuminfo.s3_picture_url;
  } else if (albuminfo.album_picture_url) {
    picture_url = albuminfo.album_picture_url;
  }

  const tooltip = <Tooltip id="tooltip">copy song link</Tooltip>;
  const copied_tooltip = <Tooltip id="tooltip">copied song url!</Tooltip>;
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const copyLink = () => {
    // Your copy link logic here
    navigator.clipboard.writeText(window.location.href);
    setShowCopiedTooltip(true);
    setTimeout(() => {
      setShowCopiedTooltip(false);
    }, 1000); // Tooltip will disappear after 1 second
  };

  return (
    <div className="song-details">
      <div className="song-cards">
        <div className="song-left-card">
          <h5 className="album-name-song-page">
            {song.spotify_song_id &&
              <a href={`https://open.spotify.com/track/${song.spotify_song_id}`} target="_blank" rel="noopener noreferrer">
                <img src="/spotify_logo.png" alt="Listen on Spotify" style={{ width: "16px", height: "16px", boxShadow: "none" }} />
              </a>
            }
            TRACK {song.track_order} ON{" "}
            <Link to={`/album/${encodeId(album_id)}`} state={{ id: album_id }} className="a-name-link">
              {albuminfo.album_english_name.toUpperCase()}
            </Link>{" "}

          </h5>

          <div className="artist-photo-wrapper">
            <Link to={`/album/${encodeId(album_id)}`} state={{ id: album_id }}>
              <img
                className="main-photo"
                src={picture_url}
                alt={"album photo of " + albuminfo.album_english_name}
                onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
                  event.currentTarget.src = "/dubuFace.jpg";
                  event.currentTarget.onerror = null;
                }}
              />
            </Link>
          </div>

          {showSongHeader(song, featured, artistinfo, albuminfo, "")}
          {showSongHeader(song, featured, artistinfo, albuminfo, "-mobile")}
          <UserRatingUI itemId={song.melon_song_id} itemType="song" />


        </div>
        <div className="song-right-card">
          {song.youtube_id && (
            <div className="song-youtube-video">
              <iframe style={{ "borderRadius": "1em" }}
                src={`https://www.youtube.com/embed/${song.youtube_id}`}
                title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin" allowFullScreen ></iframe>
            </div>)}
          <div className="song-credits">
            {written.length > 0 && (
              <div className="artist-credit-list">
                <p style={{ "fontSize": "1.1em", "fontWeight": "600" }}>LYRICS</p><hr></hr>
                <CreditListPerSong credits={written as any} />
              </div>)}
            {composed.length > 0 && (
              <div className="artist-credit-list">
                <p style={{ "fontSize": "1.1em", "fontWeight": "600" }}>
                  COMPOSITION
                </p><hr></hr>
                <CreditListPerSong credits={composed as any} />
              </div>)}
            {arranged.length > 0 && (
              <div className="artist-credit-list">
                <p style={{ "fontSize": "1.1em", "fontWeight": "600" }}>
                  {" "}
                  ARRANGEMENT
                </p><hr></hr>
                <CreditListPerSong credits={arranged as any} />
              </div>
            )}
          </div>
          {/* </Tab>
            <Tab eventKey="reviews" title="REVIEWS"> */}

          <ReviewsContainer songId={song.melon_song_id} />
          {/* </Tab>
          </Tabs> */}
          <div className="all-info">
            {song.logged_at && (
              <i>
                data last updated on {song.logged_at.toString().slice(0, 10)}.
              </i>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SongDetails;
